import { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
// import { RolePermissionsSchema } from './RolePermissions.ValidationSchema';
import { toast } from "react-toastify";
import { FormField } from "../../../../Components/FormField";
import SidebarField from "../../../../Components/SidebarField";
import SelectDropdown from "../../../../Components/Dropdown/SelectDropdown";
import Button from "../../../../Components/Button";
import {
  ComponentApi,
  ComponentTypeApi,
} from "../../../../App/api/role_and_permissions.api";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import ToggleField from "../../../../Components/ToggleField";
import { ComponentSchema } from "./ValidationSchema";
import { AfterLoginRoutes } from "../../../../Router/router";

function AddComponent({ currentItems, getAllData, open, handleClose }) {
  const ComponentTypesData = useFetchAll(() =>
    ComponentTypeApi.getAllComponentTypesData()
  );

  const { value, fetchAllData } = useFetchAll(() =>
    ComponentApi.getAllComponentGetMethod()
  );
  // console.log("value", value);
 
  // console.log("currentItems", currentItems);

  const initialValues = {
    name: currentItems?.name || "",
    componentType: currentItems?.componentType || "",
    link:null
  };

  let componenetFilteredData = AfterLoginRoutes?.map((item) => {
    return { name: item?.meta?.name,link:item?.meta?.link };
  });

  componenetFilteredData = componenetFilteredData.filter(
    (item1) => !value?.data?.some((item2) => item2.name === item1.name)
  );

  // console.log("componenetFilteredData", componenetFilteredData);

  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Data", values);

    try {
      // console.log("values", values);
      currentItems?._id
        ? await ComponentApi.updateComponent(values, currentItems._id)
        : await ComponentApi.createComponent(values);

      getAllData();
      fetchAllData();
      toast.success(
        currentItems?._id ? "Component updated" : "Component created"
      );
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={ComponentSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id ? "Update Component" : "Add New Component"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit"
                  />
                }
              >
                <FormField label="Component" tooltip="Enter Component name">
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values?.name}
                    inputName="name"
                    placeholder="Select Component"
                    options={componenetFilteredData || []}
                    handleFilter={(name, v) => {
                      const permissionOptions = componenetFilteredData.filter(
                        (item) => v === item.name
                      );
                      console.log('permissionOptions',permissionOptions);
                      // console.log('v',v);
                      
                     
                      setFieldValue("name", v);
                      setFieldValue("link", permissionOptions[0]?.link);
                    }}
                    optionLabel="name"
                    optionValue="name"
                  />
                  <ErrorMessage
                    name="Component name"
                    component="p"
                    className="error"
                  />
                </FormField>

                <FormField
                  label="Component Type"
                  tooltip="Choose Component Type"
                >
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.componentType}
                    inputName="componentType"
                    placeholder="Select Component Type"
                    options={ComponentTypesData.value?.data || []}
                    handleFilter={(name, v) => {                   
                    
                      setFieldValue("componentType", v);
                    }}
                    optionLabel="name"
                    optionValue="_id"
                  />
                  <ErrorMessage
                    name="componentType"
                    component="p"
                    className="error"
                  />
                </FormField>
                {/* <FormField label="Permissions" tooltip="Choose permissions">                   
                     <MultiSelectDropDown
                        sx={{ width: '100%' }} // Optional custom style
                        name={`permissions`}
                        value={values.permissions}
                        options={permissionOptions}
                        placeholder="Select options"
                        handleMultiselectChange={(e)=>{
                            console.log(e);
                            setFieldValue('permissions',e)
                            
                        }}
                        optionLabel="permissionName"
                        // optionValue="permissionId"
                    />
                  <ErrorMessage name="permissions" component="p" className="error" />
                </FormField>   */}
                <div>
                  <ToggleField
                    text={values.active ? "Enabled" : "Disabled"}
                    name="active"
                    value={values.active}
                    toggaleHandleChange={(e) => {
                      // console.log("v", e.target.value);

                      setFieldValue("active", e.target.value);
                    }}
                  />
                  <ErrorMessage name="active" component="p" className="error" />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddComponent;
